/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

// UNUSED EXPORTS: Button

;// ./node_modules/@lit/reactive-element/css-tag.js
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t=globalThis,e=t.ShadowRoot&&(void 0===t.ShadyCSS||t.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s=Symbol(),o=new WeakMap;class n{constructor(t,e,o){if(this._$cssResult$=!0,o!==s)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const s=this.t;if(e&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=o.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&o.set(s,t))}return t}toString(){return this.cssText}}const r=t=>new n("string"==typeof t?t:t+"",void 0,s),i=(t,...e)=>{const o=1===t.length?t[0]:e.reduce((e,s,o)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[o+1],t[0]);return new n(o,t,s)},S=(s,o)=>{if(e)s.adoptedStyleSheets=o.map(t=>t instanceof CSSStyleSheet?t:t.styleSheet);else for(const e of o){const o=document.createElement("style"),n=t.litNonce;void 0!==n&&o.setAttribute("nonce",n),o.textContent=e.cssText,s.appendChild(o)}},c=e?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r(e)})(t):t;
//# sourceMappingURL=css-tag.js.map

;// ./node_modules/@lit/reactive-element/reactive-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:reactive_element_i,defineProperty:reactive_element_e,getOwnPropertyDescriptor:h,getOwnPropertyNames:reactive_element_r,getOwnPropertySymbols:reactive_element_o,getPrototypeOf:reactive_element_n}=Object,a=globalThis,reactive_element_c=a.trustedTypes,l=reactive_element_c?reactive_element_c.emptyScript:"",p=a.reactiveElementPolyfillSupport,d=(t,s)=>t,u={toAttribute(t,s){switch(s){case Boolean:t=t?l:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,s){let i=t;switch(s){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t)}catch(t){i=null}}return i}},f=(t,s)=>!reactive_element_i(t,s),b={attribute:!0,type:String,converter:u,reflect:!1,useDefault:!1,hasChanged:f};Symbol.metadata??=Symbol("metadata"),a.litPropertyMetadata??=new WeakMap;class y extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??=[]).push(t)}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,s=b){if(s.state&&(s.attribute=!1),this._$Ei(),this.prototype.hasOwnProperty(t)&&((s=Object.create(s)).wrapped=!0),this.elementProperties.set(t,s),!s.noAccessor){const i=Symbol(),h=this.getPropertyDescriptor(t,i,s);void 0!==h&&reactive_element_e(this.prototype,t,h)}}static getPropertyDescriptor(t,s,i){const{get:e,set:r}=h(this.prototype,t)??{get(){return this[s]},set(t){this[s]=t}};return{get:e,set(s){const h=e?.call(this);r?.call(this,s),this.requestUpdate(t,h,i)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)??b}static _$Ei(){if(this.hasOwnProperty(d("elementProperties")))return;const t=reactive_element_n(this);t.finalize(),void 0!==t.l&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties)}static finalize(){if(this.hasOwnProperty(d("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(d("properties"))){const t=this.properties,s=[...reactive_element_r(t),...reactive_element_o(t)];for(const i of s)this.createProperty(i,t[i])}const t=this[Symbol.metadata];if(null!==t){const s=litPropertyMetadata.get(t);if(void 0!==s)for(const[t,i]of s)this.elementProperties.set(t,i)}this._$Eh=new Map;for(const[t,s]of this.elementProperties){const i=this._$Eu(t,s);void 0!==i&&this._$Eh.set(i,t)}this.elementStyles=this.finalizeStyles(this.styles)}static finalizeStyles(s){const i=[];if(Array.isArray(s)){const e=new Set(s.flat(1/0).reverse());for(const s of e)i.unshift(c(s))}else void 0!==s&&i.push(c(s));return i}static _$Eu(t,s){const i=s.attribute;return!1===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev()}_$Ev(){this._$ES=new Promise(t=>this.enableUpdating=t),this._$AL=new Map,this._$E_(),this.requestUpdate(),this.constructor.l?.forEach(t=>t(this))}addController(t){(this._$EO??=new Set).add(t),void 0!==this.renderRoot&&this.isConnected&&t.hostConnected?.()}removeController(t){this._$EO?.delete(t)}_$E_(){const t=new Map,s=this.constructor.elementProperties;for(const i of s.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t)}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return S(t,this.constructor.elementStyles),t}connectedCallback(){this.renderRoot??=this.createRenderRoot(),this.enableUpdating(!0),this._$EO?.forEach(t=>t.hostConnected?.())}enableUpdating(t){}disconnectedCallback(){this._$EO?.forEach(t=>t.hostDisconnected?.())}attributeChangedCallback(t,s,i){this._$AK(t,i)}_$ET(t,s){const i=this.constructor.elementProperties.get(t),e=this.constructor._$Eu(t,i);if(void 0!==e&&!0===i.reflect){const h=(void 0!==i.converter?.toAttribute?i.converter:u).toAttribute(s,i.type);this._$Em=t,null==h?this.removeAttribute(e):this.setAttribute(e,h),this._$Em=null}}_$AK(t,s){const i=this.constructor,e=i._$Eh.get(t);if(void 0!==e&&this._$Em!==e){const t=i.getPropertyOptions(e),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==t.converter?.fromAttribute?t.converter:u;this._$Em=e;const r=h.fromAttribute(s,t.type);this[e]=r??this._$Ej?.get(e)??r,this._$Em=null}}requestUpdate(t,s,i,e=!1,h){if(void 0!==t){const r=this.constructor;if(!1===e&&(h=this[t]),i??=r.getPropertyOptions(t),!((i.hasChanged??f)(h,s)||i.useDefault&&i.reflect&&h===this._$Ej?.get(t)&&!this.hasAttribute(r._$Eu(t,i))))return;this.C(t,s,i)}!1===this.isUpdatePending&&(this._$ES=this._$EP())}C(t,s,{useDefault:i,reflect:e,wrapped:h},r){i&&!(this._$Ej??=new Map).has(t)&&(this._$Ej.set(t,r??s??this[t]),!0!==h||void 0!==r)||(this._$AL.has(t)||(this.hasUpdated||i||(s=void 0),this._$AL.set(t,s)),!0===e&&this._$Em!==t&&(this._$Eq??=new Set).add(t))}async _$EP(){this.isUpdatePending=!0;try{await this._$ES}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??=this.createRenderRoot(),this._$Ep){for(const[t,s]of this._$Ep)this[t]=s;this._$Ep=void 0}const t=this.constructor.elementProperties;if(t.size>0)for(const[s,i]of t){const{wrapped:t}=i,e=this[s];!0!==t||this._$AL.has(s)||void 0===e||this.C(s,void 0,i,e)}}let t=!1;const s=this._$AL;try{t=this.shouldUpdate(s),t?(this.willUpdate(s),this._$EO?.forEach(t=>t.hostUpdate?.()),this.update(s)):this._$EM()}catch(s){throw t=!1,this._$EM(),s}t&&this._$AE(s)}willUpdate(t){}_$AE(t){this._$EO?.forEach(t=>t.hostUpdated?.()),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EM(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return!0}update(t){this._$Eq&&=this._$Eq.forEach(t=>this._$ET(t,this[t])),this._$EM()}updated(t){}firstUpdated(t){}}y.elementStyles=[],y.shadowRootOptions={mode:"open"},y[d("elementProperties")]=new Map,y[d("finalized")]=new Map,p?.({ReactiveElement:y}),(a.reactiveElementVersions??=[]).push("2.1.2");
//# sourceMappingURL=reactive-element.js.map

;// ./node_modules/lit-html/lit-html.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const lit_html_t=globalThis,lit_html_i=t=>t,lit_html_s=lit_html_t.trustedTypes,lit_html_e=lit_html_s?lit_html_s.createPolicy("lit-html",{createHTML:t=>t}):void 0,lit_html_h="$lit$",lit_html_o=`lit$${Math.random().toFixed(9).slice(2)}$`,lit_html_n="?"+lit_html_o,lit_html_r=`<${lit_html_n}>`,lit_html_l=document,lit_html_c=()=>lit_html_l.createComment(""),lit_html_a=t=>null===t||"object"!=typeof t&&"function"!=typeof t,lit_html_u=Array.isArray,lit_html_d=t=>lit_html_u(t)||"function"==typeof t?.[Symbol.iterator],lit_html_f="[ \t\n\f\r]",v=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_=/-->/g,m=/>/g,lit_html_p=RegExp(`>|${lit_html_f}(?:([^\\s"'>=/]+)(${lit_html_f}*=${lit_html_f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g=/'/g,$=/"/g,lit_html_y=/^(?:script|style|textarea|title)$/i,x=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),lit_html_b=x(1),w=x(2),T=x(3),E=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),C=new WeakMap,P=lit_html_l.createTreeWalker(lit_html_l,129);function V(t,i){if(!lit_html_u(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==lit_html_e?lit_html_e.createHTML(i):i}const N=(t,i)=>{const s=t.length-1,e=[];let n,l=2===i?"<svg>":3===i?"<math>":"",c=v;for(let i=0;i<s;i++){const s=t[i];let a,u,d=-1,f=0;for(;f<s.length&&(c.lastIndex=f,u=c.exec(s),null!==u);)f=c.lastIndex,c===v?"!--"===u[1]?c=_:void 0!==u[1]?c=m:void 0!==u[2]?(lit_html_y.test(u[2])&&(n=RegExp("</"+u[2],"g")),c=lit_html_p):void 0!==u[3]&&(c=lit_html_p):c===lit_html_p?">"===u[0]?(c=n??v,d=-1):void 0===u[1]?d=-2:(d=c.lastIndex-u[2].length,a=u[1],c=void 0===u[3]?lit_html_p:'"'===u[3]?$:g):c===$||c===g?c=lit_html_p:c===_||c===m?c=v:(c=lit_html_p,n=void 0);const x=c===lit_html_p&&t[i+1].startsWith("/>")?" ":"";l+=c===v?s+lit_html_r:d>=0?(e.push(a),s.slice(0,d)+lit_html_h+s.slice(d)+lit_html_o+x):s+lit_html_o+(-2===d?i:x)}return[V(t,l+(t[s]||"<?>")+(2===i?"</svg>":3===i?"</math>":"")),e]};class lit_html_S{constructor({strings:t,_$litType$:i},e){let r;this.parts=[];let l=0,a=0;const u=t.length-1,d=this.parts,[f,v]=N(t,i);if(this.el=lit_html_S.createElement(f,e),P.currentNode=this.el.content,2===i||3===i){const t=this.el.content.firstChild;t.replaceWith(...t.childNodes)}for(;null!==(r=P.nextNode())&&d.length<u;){if(1===r.nodeType){if(r.hasAttributes())for(const t of r.getAttributeNames())if(t.endsWith(lit_html_h)){const i=v[a++],s=r.getAttribute(t).split(lit_html_o),e=/([.?@])?(.*)/.exec(i);d.push({type:1,index:l,name:e[2],strings:s,ctor:"."===e[1]?I:"?"===e[1]?L:"@"===e[1]?z:H}),r.removeAttribute(t)}else t.startsWith(lit_html_o)&&(d.push({type:6,index:l}),r.removeAttribute(t));if(lit_html_y.test(r.tagName)){const t=r.textContent.split(lit_html_o),i=t.length-1;if(i>0){r.textContent=lit_html_s?lit_html_s.emptyScript:"";for(let s=0;s<i;s++)r.append(t[s],lit_html_c()),P.nextNode(),d.push({type:2,index:++l});r.append(t[i],lit_html_c())}}}else if(8===r.nodeType)if(r.data===lit_html_n)d.push({type:2,index:l});else{let t=-1;for(;-1!==(t=r.data.indexOf(lit_html_o,t+1));)d.push({type:7,index:l}),t+=lit_html_o.length-1}l++}}static createElement(t,i){const s=lit_html_l.createElement("template");return s.innerHTML=t,s}}function M(t,i,s=t,e){if(i===E)return i;let h=void 0!==e?s._$Co?.[e]:s._$Cl;const o=lit_html_a(i)?void 0:i._$litDirective$;return h?.constructor!==o&&(h?._$AO?.(!1),void 0===o?h=void 0:(h=new o(t),h._$AT(t,s,e)),void 0!==e?(s._$Co??=[])[e]=h:s._$Cl=h),void 0!==h&&(i=M(t,h._$AS(t,i.values),h,e)),i}class R{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:s}=this._$AD,e=(t?.creationScope??lit_html_l).importNode(i,!0);P.currentNode=e;let h=P.nextNode(),o=0,n=0,r=s[0];for(;void 0!==r;){if(o===r.index){let i;2===r.type?i=new k(h,h.nextSibling,this,t):1===r.type?i=new r.ctor(h,r.name,r.strings,this,t):6===r.type&&(i=new Z(h,this,t)),this._$AV.push(i),r=s[++n]}o!==r?.index&&(h=P.nextNode(),o++)}return P.currentNode=lit_html_l,e}p(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++}}class k{get _$AU(){return this._$AM?._$AU??this._$Cv}constructor(t,i,s,e){this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cv=e?.isConnected??!0}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t?.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=M(this,t,i),lit_html_a(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==E&&this._(t):void 0!==t._$litType$?this.$(t):void 0!==t.nodeType?this.T(t):lit_html_d(t)?this.k(t):this._(t)}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t))}_(t){this._$AH!==A&&lit_html_a(this._$AH)?this._$AA.nextSibling.data=t:this.T(lit_html_l.createTextNode(t)),this._$AH=t}$(t){const{values:i,_$litType$:s}=t,e="number"==typeof s?this._$AC(t):(void 0===s.el&&(s.el=lit_html_S.createElement(V(s.h,s.h[0]),this.options)),s);if(this._$AH?._$AD===e)this._$AH.p(i);else{const t=new R(e,this),s=t.u(this.options);t.p(i),this.T(s),this._$AH=t}}_$AC(t){let i=C.get(t.strings);return void 0===i&&C.set(t.strings,i=new lit_html_S(t)),i}k(t){lit_html_u(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const h of t)e===i.length?i.push(s=new k(this.O(lit_html_c()),this.O(lit_html_c()),this,this.options)):s=i[e],s._$AI(h),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e)}_$AR(t=this._$AA.nextSibling,s){for(this._$AP?.(!1,!0,s);t!==this._$AB;){const s=lit_html_i(t).nextSibling;lit_html_i(t).remove(),t=s}}setConnected(t){void 0===this._$AM&&(this._$Cv=t,this._$AP?.(t))}}class H{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,s,e,h){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=h,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A}_$AI(t,i=this,s,e){const h=this.strings;let o=!1;if(void 0===h)t=M(this,t,i,0),o=!lit_html_a(t)||t!==this._$AH&&t!==E,o&&(this._$AH=t);else{const e=t;let n,r;for(t=h[0],n=0;n<h.length-1;n++)r=M(this,e[s+n],i,n),r===E&&(r=this._$AH[n]),o||=!lit_html_a(r)||r!==this._$AH[n],r===A?t=A:t!==A&&(t+=(r??"")+h[n+1]),this._$AH[n]=r}o&&!e&&this.j(t)}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"")}}class I extends H{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===A?void 0:t}}class L extends H{constructor(){super(...arguments),this.type=4}j(t){this.element.toggleAttribute(this.name,!!t&&t!==A)}}class z extends H{constructor(t,i,s,e,h){super(t,i,s,e,h),this.type=5}_$AI(t,i=this){if((t=M(this,t,i,0)??A)===E)return;const s=this._$AH,e=t===A&&s!==A||t.capture!==s.capture||t.once!==s.once||t.passive!==s.passive,h=t!==A&&(s===A||e);e&&this.element.removeEventListener(this.name,this,s),h&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){"function"==typeof this._$AH?this._$AH.call(this.options?.host??this.element,t):this._$AH.handleEvent(t)}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s}get _$AU(){return this._$AM._$AU}_$AI(t){M(this,t)}}const j={M:lit_html_h,P:lit_html_o,A:lit_html_n,C:1,L:N,R,D:lit_html_d,V:M,I:k,H,N:L,U:z,B:I,F:Z},B=lit_html_t.litHtmlPolyfillSupport;B?.(lit_html_S,k),(lit_html_t.litHtmlVersions??=[]).push("3.3.2");const D=(t,i,s)=>{const e=s?.renderBefore??i;let h=e._$litPart$;if(void 0===h){const t=s?.renderBefore??null;e._$litPart$=h=new k(i.insertBefore(lit_html_c(),t),t,void 0,s??{})}return h._$AI(t),h};
//# sourceMappingURL=lit-html.js.map

;// ./node_modules/lit-element/lit-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const lit_element_s=globalThis;class lit_element_i extends y{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){const t=super.createRenderRoot();return this.renderOptions.renderBefore??=t.firstChild,t}update(t){const r=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D(r,this.renderRoot,this.renderOptions)}connectedCallback(){super.connectedCallback(),this._$Do?.setConnected(!0)}disconnectedCallback(){super.disconnectedCallback(),this._$Do?.setConnected(!1)}render(){return E}}lit_element_i._$litElement$=!0,lit_element_i["finalized"]=!0,lit_element_s.litElementHydrateSupport?.({LitElement:lit_element_i});const lit_element_o=lit_element_s.litElementPolyfillSupport;lit_element_o?.({LitElement:lit_element_i});const lit_element_n={_$AK:(t,e,r)=>{t._$AK(e,r)},_$AL:t=>t._$AL};(lit_element_s.litElementVersions??=[]).push("4.2.2");
//# sourceMappingURL=lit-element.js.map

;// ./node_modules/lit/index.js

//# sourceMappingURL=index.js.map

;// ./src/v2/components/actions/button/Button.ts

class Button extends lit_element_i {
  static properties = {
    label: {
      type: String,
      reflect: true
    },
    type: {
      type: String,
      reflect: true
    },
    disabled: {
      type: Boolean,
      reflect: true
    },
    selected: {
      type: Boolean,
      reflect: true
    },
    ariaLabel: {
      type: String,
      attribute: 'aria-label'
    },
    name: {
      type: String,
      reflect: true
    },
    value: {
      type: String,
      reflect: true
    },
    variant: {
      type: String,
      reflect: true
    },
    size: {
      type: String,
      reflect: true
    },
    theme: {
      type: String,
      reflect: true
    },
    fullWidth: {
      type: Boolean,
      attribute: 'full-width',
      reflect: true
    },
    icon: {
      type: String,
      reflect: true
    },
    iconPosition: {
      type: String,
      attribute: 'icon-position',
      reflect: true
    },
    contentAlign: {
      type: String,
      attribute: 'content-align',
      reflect: true
    },
    handleClick: {
      attribute: false
    },
    _hasSlottedIcon: {
      state: true
    }
  };
  static styles = i`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      --button-background: var(--color-background, #f8f9fb);
      --button-text: var(--color-text-subheading, #101828);
      --button-border: var(--color-border-button, var(--gray-300, #D1D5DC));
      --button-hover-background: var(--color-surface-subtle, rgba(15, 23, 43, 0.04));
      --button-hover-border: var(--color-border-button-hover, var(--gray-400, #99A1AF));
      --button-hover-text: var(--color-text-subheading, #101828);
      --button-selected-background: var(--color-surface-selected, var(--color-surface-action, var(--color-primary, #7C4DFF)));
      --button-selected-text: var(--color-text-selected, var(--color-text-on-action, var(--white, #FFF)));
      --button-selected-border: var(--color-border-selected, var(--color-border-action, var(--color-primary, #7C4DFF)));
      --button-icon-color: currentColor;
      --button-focus-ring: var(--color-focus-ring, var(--color-primary, #7C4DFF));
      --button-height-sm: 1.875rem;
      --button-height-md: var(--min-touch-target, 44px);
      --button-height-lg: calc(var(--min-touch-target, 44px) + 0.5rem);
      --button-padding-x-sm: var(--spacing-xs, 0.75rem);
      --button-padding-x-md: var(--spacing-sm, 0.9375rem);
      --button-padding-x-lg: var(--spacing-md, 1.25rem);
      --button-font-size-sm: var(--font-size-sm, 0.875rem);
      --button-font-size-md: var(--font-size-md, 1rem);
      --button-font-size-lg: var(--font-size-lg, 1.125rem);
      --button-icon-size-sm: var(--icon-xxxs, 0.75rem);
      --button-icon-size-md: var(--icon-xxs, 1rem);
      --button-icon-size-lg: var(--icon-xxs, 1rem);
      --button-padding-sm: 0 var(--button-padding-x-sm);
      --button-padding-md: 0 var(--button-padding-x-md);
      --button-padding-lg: 0 var(--button-padding-x-lg);
      --button-border-width: 1px;
      --button-border-radius: var(--border-radius-base, 0.3125rem);
      --button-font-weight: var(--font-weight-bold, 600);
      --button-line-height: 1;
      --button-justify-content: center;
      --button-content-justify-content: var(--button-justify-content);
      --button-label-text-align: center;
      --button-box-shadow: none;
      --button-hover-box-shadow: var(--button-box-shadow);
      --button-active-box-shadow: var(--button-hover-box-shadow);
      --button-active-transform: translateY(1px);
      --button-focus-outline: 2px solid var(--button-focus-ring);
      --button-focus-outline-offset: 2px;
      --button-focus-box-shadow: none;
      --button-transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
    }

    :host([hidden]) {
      display: none;
    }

    :host([theme='dark']) {
      --button-background: var(--color-background, #242a31);
      --button-text: var(--color-text-subheading, #f8f9fb);
      --button-border: var(--color-border, #46515b);
      --button-hover-background: var(--color-surface-subtle, rgba(15, 23, 43, 0.04));
      --button-hover-border: var(--color-border, #46515b);
      --button-hover-text: var(--color-text-subheading, #f8f9fb);
    }

    :host([variant='primary']) {
      --button-background: var(--color-surface-action, var(--color-primary, #7C4DFF));
      --button-text: var(--color-text-on-action, var(--white, #FFF));
      --button-border: var(--color-border-action, var(--color-primary, #7C4DFF));
      --button-hover-background: var(--color-surface-action-hover, #6d3cf2);
      --button-hover-border: var(--color-border-action, var(--color-primary, #7C4DFF));
      --button-hover-text: var(--color-text-on-action, var(--white, #FFF));
    }

    :host([variant='icon']) {
      --button-padding-x-sm: var(--spacing-xxs, 0.3125rem);
      --button-padding-x-md: var(--spacing-base, 0.5rem);
      --button-padding-x-lg: var(--spacing-2xs, 0.625rem);
    }

    :host([full-width]) {
      width: 100%;
    }

    :host([content-align='start']) {
      --button-justify-content: flex-start;
      --button-content-justify-content: flex-start;
      --button-label-text-align: left;
    }

    :host([content-align='end']) {
      --button-justify-content: flex-end;
      --button-content-justify-content: flex-end;
      --button-label-text-align: right;
    }

    :host([selected]) {
      --button-background: var(--button-selected-background);
      --button-text: var(--button-selected-text);
      --button-border: var(--button-selected-border);
    }

    .button {
      display: inline-flex;
      width: 100%;
      min-height: var(--button-height-md);
      padding: var(--button-padding-md);
      align-items: center;
      justify-content: var(--button-justify-content);
      gap: var(--spacing-xxs, 0.375rem);
      border-radius: var(--button-border-radius);
      background: var(--button-background);
      border: var(--button-border-width) solid var(--button-border);
      box-shadow: var(--button-box-shadow);
      color: var(--button-text);
      cursor: pointer;
      font: inherit;
      font-size: var(--button-font-size-md);
      font-weight: var(--button-font-weight);
      line-height: var(--button-line-height);
      white-space: nowrap;
      text-decoration: none;
      box-sizing: border-box;
      transition: var(--button-transition);
    }

    :host([size='sm']) .button {
      min-height: var(--button-height-sm);
      padding: var(--button-padding-sm);
      font-size: var(--button-font-size-sm);
    }

    :host([size='lg']) .button {
      min-height: var(--button-height-lg);
      padding: var(--button-padding-lg);
      font-size: var(--button-font-size-lg);
    }

    .button:hover:not(:disabled) {
      background: var(--button-hover-background);
      border-color: var(--button-hover-border, var(--button-border));
      box-shadow: var(--button-hover-box-shadow, var(--button-box-shadow));
      color: var(--button-hover-text);
    }

    :host([selected]) .button:hover:not(:disabled) {
      background: var(--button-hover-background);
      border-color: var(--button-selected-border);
      color: var(--button-selected-text);
    }
      
    .button:focus-visible {
      outline: var(--button-focus-outline);
      outline-offset: var(--button-focus-outline-offset);
      box-shadow: var(--button-focus-box-shadow);
    }

    .button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    .button__content {
      display: inline-flex;
      align-items: center;
      justify-content: var(--button-content-justify-content);
      gap: inherit;
      width: 100%;
    }

    :host([icon-position='end']) .button__content {
      flex-direction: row-reverse;
    }

    .button__icon {
      width: var(--button-icon-size-md);
      height: var(--button-icon-size-md);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: var(--button-icon-color);
      flex-shrink: 0;
    }

    :host([size='sm']) .button__icon {
      width: var(--button-icon-size-sm);
      height: var(--button-icon-size-sm);
    }

    :host([size='lg']) .button__icon {
      width: var(--button-icon-size-lg);
      height: var(--button-icon-size-lg);
    }

    .button__icon ::slotted(*) {
      width: 100%;
      height: 100%;
      display: block;
    }

    .button__icon-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .button__label {
      display: inline-flex;
      align-items: center;
      justify-content: var(--button-content-justify-content);
      min-width: 0;
      width: 100%;
      text-align: var(--button-label-text-align);
    }

    :host([variant='icon']) .button__label {
      display: none;
    }

    .button:active {
      transform: var(--button-active-transform);
      box-shadow: var(--button-active-box-shadow, var(--button-hover-box-shadow, var(--button-box-shadow)));
    }
  `;
  _iconSlotObserver;
  constructor() {
    super();
    this.label = '';
    this.type = 'button';
    this.disabled = false;
    this.selected = false;
    this.ariaLabel = '';
    this.name = '';
    this.value = '';
    this.variant = 'secondary';
    this.size = 'md';
    this.theme = 'light';
    this.fullWidth = false;
    this.icon = '';
    this.iconPosition = 'start';
    this.contentAlign = 'center';
    this.handleClick = undefined;
    this._hasSlottedIcon = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this._syncSlottedIconPresence();
    this._iconSlotObserver = new MutationObserver(() => {
      this._syncSlottedIconPresence();
    });
    this._iconSlotObserver.observe(this, {
      childList: true,
      attributes: true,
      attributeFilter: ['slot']
    });
  }
  disconnectedCallback() {
    this._iconSlotObserver?.disconnect();
    this._iconSlotObserver = undefined;
    super.disconnectedCallback();
  }
  _handleButtonClick(event) {
    this.handleClick?.(event);
  }
  _handleIconSlotChange(event) {
    const slot = event.target;
    this._hasSlottedIcon = slot.assignedNodes({
      flatten: true
    }).length > 0;
  }
  _syncSlottedIconPresence() {
    this._hasSlottedIcon = this.querySelector('[slot="icon"]') !== null;
  }
  _renderIcon() {
    if (!this._hasSlottedIcon && !this.icon) {
      return A;
    }
    return lit_html_b`
      <span class="button__icon" part="icon">
        <slot name="icon" @slotchange=${this._handleIconSlotChange}></slot>
        ${!this._hasSlottedIcon && this.icon ? lit_html_b`<img class="button__icon-image" src=${this.icon} alt="" aria-hidden="true" />` : A}
      </span>
    `;
  }
  render() {
    return lit_html_b`
      <button
        class="button"
        type=${this.type}
        ?disabled=${this.disabled}
        aria-label=${this.ariaLabel || A}
        name=${this.name || A}
        value=${this.value || A}
        part="button"
        @click=${this._handleButtonClick}
      >
        <span class="button__content">
          ${this._renderIcon()}
          <span class="button__label" part="label">
            <slot>${this.label}</slot>
          </span>
        </span>
      </button>
    `;
  }
}
;// ./src/v2/components/actions/button/index.ts


const BUTTON_TAG_NAME = 'solid-ui-button';
if (!customElements.get(BUTTON_TAG_NAME)) {
  customElements.define(BUTTON_TAG_NAME, Button);
}
/******/ })()
;
//# sourceMappingURL=index.js.map